import { TeacherVoiceGame } from '../TeacherVoiceGame.component';

const BASE_URL = 'https://nowwithfeeling.com';

/**
 * To navigate outside of this activity into the main site
 * We have to use a deep link in order for the page to be displayed
 * since it is in a different repo. The links are stored here so
 * if something is changed, it is easy to fix.
 */

export const externalRoutes = {
    home: BASE_URL,
    learnMore: `${BASE_URL}/learnMore`,
    aboutUs: `${BASE_URL}/aboutUs`,
    survey: 'https://www.surveymonkey.ca/r/9WCG866',
};

export const routePaths = {
    TEACHER_VOICE: '/teacherVoice',
};

export const internalRoutes = [
    {
        path: routePaths.TEACHER_VOICE,
        component: TeacherVoiceGame,
    },
];
